module.exports = __webpack_public_path__ + "img/suppliers-active.33afb9dc.svg";